import { AxiosError } from 'axios'
import { OUT_OF_TIER } from './codes'

export type StorageQuotaServerError = {
  byPhotoQuota: boolean
  byStorageQuota: boolean
  photoQuotaLimit?: number
}

export function parseStorageQuotaServerError(
  error: unknown
): StorageQuotaServerError | null {
  if (!(error instanceof AxiosError)) return null
  if (error.response?.status !== 403) return null

  const responseData =
    (error.response?.data as Record<string, unknown> | undefined) ?? {}

  if (responseData.code !== OUT_OF_TIER) return null

  const byPhotoQuota = responseData.byPhotoQuota === true
  const byStorageQuota = responseData.byStorageQuota === true

  if (!byPhotoQuota && !byStorageQuota) return null

  const photoQuotaLimit = Number(responseData.photoQuotaLimit)

  return {
    byPhotoQuota,
    byStorageQuota,
    photoQuotaLimit: Number.isFinite(photoQuotaLimit)
      ? photoQuotaLimit
      : undefined
  }
}
